import { Separator } from "@/components/ui/separator";
import SectionSubtitle from "../SectionSubtitle";

type ConversationsBilledCardProps = {
  conversationsTotal?: number;
  conversationsCost?: number;
  outboundsTotal?: number;
  outboundsCost?: number;
  callMinutesTotal?: number;
  callMinutesCost?: number;
};

const BillableConversationsCard = ({
  conversationsTotal,
  conversationsCost,
  outboundsTotal,
  outboundsCost,
  callMinutesTotal,
  callMinutesCost,
}: ConversationsBilledCardProps) => {
  const formatCurrency = (num: number) => {
    return Math.round(num).toLocaleString("es-ES");
  };

  const hasConversationData = conversationsTotal !== undefined && conversationsCost !== undefined;
  const hasOutboundData =
    outboundsTotal !== undefined && outboundsCost !== undefined && outboundsTotal !== 0;
  const hasCallMinutesData =
    callMinutesTotal !== undefined && callMinutesCost !== undefined && callMinutesTotal !== 0;

  if (!hasConversationData && !hasOutboundData && !hasCallMinutesData) {
    return null;
  }

  return (
    <div className="h-full rounded-lg border bg-card shadow-md">
      <div className="p-6">
        <SectionSubtitle subtitle="Consumo Período Seleccionado" />

        {hasConversationData && (
          <div className="mt-4 flex flex-col">
            <div>
              <p className="text-sm text-gray-secondary">Total de conversaciones facturadas</p>
              <p className="text-2xl font-bold text-palomma-primary">
                {Math.round(conversationsTotal!)}
              </p>
              <p className="text-sm text-muted-foreground">conversaciones en el período actual</p>
            </div>

            <div className="mt-4 rounded-md bg-gray-tertiary p-4">
              <p className="mb-2 font-medium text-palomma-secondary">
                Costo total: ${formatCurrency(conversationsCost!)}
              </p>
              <p className="text-sm text-gray-secondary">
                Facturamos una conversación por mensajes con más de 24 horas de diferencia entre
                ellos.
              </p>
            </div>
          </div>
        )}

        {hasConversationData && hasOutboundData && <Separator className="my-6" />}

        {hasOutboundData && (
          <div className="mt-4 flex flex-col">
            <div>
              <p className="text-sm text-gray-secondary">Total Plantillas Salientes</p>
              <p className="text-2xl font-bold text-palomma-primary">
                {Math.round(outboundsTotal!)}
              </p>
              <p className="text-sm text-muted-foreground">plantillas en el período actual</p>
            </div>

            <div className="mt-4 rounded-md bg-gray-tertiary p-4">
              <p className="mb-2 font-medium text-palomma-secondary">
                Costo total: ${formatCurrency(outboundsCost!)}
              </p>
              <p className="text-sm text-gray-secondary">
                Facturamos cada plantilla de WhatsApp enviada de forma saliente.
              </p>
            </div>
          </div>
        )}

        {(hasConversationData || hasOutboundData) && hasCallMinutesData && (
          <Separator className="my-6" />
        )}

        {hasCallMinutesData && (
          <div className="mt-4 flex flex-col">
            <div>
              <p className="text-sm text-gray-secondary">Total Minutos de Llamadas</p>
              <p className="text-2xl font-bold text-palomma-primary">
                {Math.round(callMinutesTotal!)}
              </p>
              <p className="text-sm text-muted-foreground">minutos en el período actual</p>
            </div>

            <div className="mt-4 rounded-md bg-gray-tertiary p-4">
              <p className="mb-2 font-medium text-palomma-secondary">
                Costo total: ${formatCurrency(callMinutesCost!)}
              </p>
              <p className="text-sm text-gray-secondary">
                Facturamos por minuto de llamada realizada por el agente.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BillableConversationsCard;
